<template>
  <Teleport to="body">
    <transition name="fade">
      <div
        v-if="show"
        class="fixed inset-0 z-50 flex items-center justify-center px-4 py-8"
        role="dialog"
        aria-modal="true"
      >
        <div class="absolute inset-0 bg-black/50" @click="emit('close')"></div>
        <div
          class="relative w-full max-w-3xl max-h-[90vh] overflow-auto rounded-2xl bg-white p-6 shadow-2xl"
        >
          <div class="flex items-start justify-between gap-4">
            <div>
              <p class="text-xs text-gray-400">좌석 배치도</p>
              <h3 class="text-lg font-semibold text-gray-900">{{ title }}</h3>
            </div>
            <button
              type="button"
              class="rounded-full p-1 text-gray-400 hover:text-gray-600"
              aria-label="닫기"
              @click="emit('close')"
            >
              <XMarkIcon class="w-5 h-5" />
            </button>
          </div>

          <div class="mt-6">
            <SeatLayout
              :layout="layout"
              :reserved-seat-numbers="reservedSeatNumbers"
              readonly
              mode="Detail"
            />
          </div>
        </div>
      </div>
    </transition>
  </Teleport>
</template>

<script setup lang="ts">
import { watch } from 'vue'
import { XMarkIcon } from '@heroicons/vue/24/outline'
import type { SeatLayoutInfo } from '@/types'
import SeatLayout from '@/components/SeatLayout.vue'

interface Props {
  show: boolean
  title: string
  layout: SeatLayoutInfo
  reservedSeatNumbers?: number[]
}

const props = withDefaults(defineProps<Props>(), {
  reservedSeatNumbers: () => []
})

const emit = defineEmits<{
  close: []
}>()

watch(
  () => props.show,
  (value) => {
    if (typeof document === 'undefined') return
    document.body.style.overflow = value ? 'hidden' : ''
  }
)
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
